// extracted by mini-css-extract-plugin
module.exports = {"oopsWrapper":"Oops_oopsWrapper__3-itv"};